var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loadingProfile,
          expression: "!loadingProfile"
        }
      ]
    },
    [
      !_vm.propCompanyId
        ? _c(
            "toolbar",
            { attrs: { title: _vm.toolbarTitle } },
            [
              _vm.hasFullAccess
                ? [
                    _c(
                      "v-menu",
                      [
                        _c("l-toolbar-button", {
                          attrs: {
                            slot: "activator",
                            label: "Status",
                            icon: "verified_user"
                          },
                          slot: "activator"
                        }),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.showAddEmployeeDialog = true
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("person_add")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v("Add Employee or Driver")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isLtnAdmin
                              ? [
                                  _vm.accountSubmission
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showOriginalSubmissionInfo = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-icon", [
                                                _vm._v("info_outline")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "Original Account Submission"
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isVerified
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showVerifyDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-icon", [
                                                _vm._v("verified_user")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v("Verify")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDisabled
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showReenableAccountDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-icon", [
                                                _vm._v("report_off")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v("Re-enable Account")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isDisabled
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showDisableAccountDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [_c("v-icon", [_vm._v("report")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v("Disable Account")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasCertificate
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openConfirmDialog()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [_c("v-icon", [_vm._v("check")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "Confirm Insurance Certificate"
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-menu",
                      [
                        _c("l-toolbar-button", {
                          attrs: {
                            slot: "activator",
                            label: "Tools",
                            icon: "link"
                          },
                          slot: "activator"
                        }),
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyListings()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("list")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [_vm._v("Load Groups")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyBids()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("attach_money")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [_vm._v("Bids")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyDispatchedLoads()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("share")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v("Dispatch Requests")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanyLoads()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("event")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [_vm._v("Loads")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.viewCompanySettlement()
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("payment")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-title", [
                                  _vm._v("Transactions")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isAdmin ||
                            _vm.isPermOffice ||
                            _vm.isPermCreateListing
                              ? _c(
                                  "v-list-tile",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push({
                                          name: "post-load",
                                          params: { id: _vm.company.id }
                                        })
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c("v-icon", [
                                          _vm._v("add_circle_outline")
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-list-tile-title", [
                                      _vm._v("Add New Load")
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("l-toolbar-button", {
                      attrs: { icon: "refresh", label: "Reload" },
                      on: {
                        click: function($event) {
                          return _vm.loadCompany()
                        }
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("confirm-insurance-modal", {
        attrs: { "company-id": _vm._.get(_vm.company, "id", null) },
        model: {
          value: _vm.showInsuranceModal,
          callback: function($$v) {
            _vm.showInsuranceModal = $$v
          },
          expression: "showInsuranceModal"
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          on: {
            input: function(v) {
              return v || _vm.restoreInviteForm()
            }
          },
          model: {
            value: _vm.showAddEmployeeDialog,
            callback: function($$v) {
              _vm.showAddEmployeeDialog = $$v
            },
            expression: "showAddEmployeeDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Add Employee or Driver")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Contact Email" },
                            model: {
                              value: _vm.inviteEmail,
                              callback: function($$v) {
                                _vm.inviteEmail = $$v
                              },
                              expression: "inviteEmail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("span", { staticClass: "subheadline accent--text" }, [
                        _vm._v("Permissions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "pl-3",
                          attrs: { small: "" },
                          on: {
                            click: function($event) {
                              _vm.openPermissionsHelp = true
                            }
                          }
                        },
                        [_vm._v("help")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Admin", value: "PERM_ADMIN" },
                            model: {
                              value: _vm.permissions,
                              callback: function($$v) {
                                _vm.permissions = $$v
                              },
                              expression: "permissions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Receiving",
                              value: "PERM_RECEIVING"
                            },
                            model: {
                              value: _vm.permissions,
                              callback: function($$v) {
                                _vm.permissions = $$v
                              },
                              expression: "permissions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Financial",
                              value: "PERM_FINANCIAL"
                            },
                            model: {
                              value: _vm.permissions,
                              callback: function($$v) {
                                _vm.permissions = $$v
                              },
                              expression: "permissions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: { label: "Office", value: "PERM_OFFICE" },
                            model: {
                              value: _vm.permissions,
                              callback: function($$v) {
                                _vm.permissions = $$v
                              },
                              expression: "permissions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { sm6: "" } }),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Dispatched Driver",
                              value: "PERM_DRIVER"
                            },
                            model: {
                              value: _vm.permissions,
                              callback: function($$v) {
                                _vm.permissions = $$v
                              },
                              expression: "permissions"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm6: "" } },
                        [
                          _vm.isLtnAdmin
                            ? _c("v-checkbox", {
                                attrs: {
                                  label: "Direct Assign",
                                  value: "PERM_LOAD_ASSIGN"
                                },
                                model: {
                                  value: _vm.permissions,
                                  callback: function($$v) {
                                    _vm.permissions = $$v
                                  },
                                  expression: "permissions"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: { click: _vm.sendInvite }
                        },
                        [_vm._v("Send Invite")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showAddEmployeeDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700" },
          model: {
            value: _vm.openPermissionsHelp,
            callback: function($$v) {
              _vm.openPermissionsHelp = $$v
            },
            expression: "openPermissionsHelp"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "lighten-2 py-3",
                  attrs: { "primary-title": "" }
                },
                [
                  _c("v-flex", [
                    _c("h3", [_vm._v("Employee Permissions")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Brief explanation of user permissions")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", color: "primary", small: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.openPermissionsHelp = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  "hide-actions": "",
                  headers: _vm.permissionDescriptionHeaders,
                  items: _vm.permissionDescriptions
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("tr", [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _c(
                              "span",
                              { staticClass: "subheading font-weight-bold" },
                              [_vm._v(_vm._s(props.item.name))]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "caption font-italic" }, [
                              _vm._v(_vm._s(props.item.usage))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.description))
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.showOriginalSubmissionInfo,
            callback: function($$v) {
              _vm.showOriginalSubmissionInfo = $$v
            },
            expression: "showOriginalSubmissionInfo"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("v-flex", [
                    _c("span", { staticClass: "subheading" }, [
                      _vm._v("Position at the company:")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-italic" }, [
                      _vm._v(_vm._s(_vm.accountSubmissionPosition))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c("span", { staticClass: "subheading" }, [
                      _vm._v("Company Focus:")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.accountSubmissionCompanyFocus, function(
                      focus,
                      focusIdx
                    ) {
                      return _c("li", { key: "focus-" + focusIdx }, [
                        _c("span", { staticClass: "font-italic" }, [
                          _vm._v(_vm._s(focus))
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c("span", { staticClass: "subheading" }, [
                      _vm._v("Other information:")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-italic" }, [
                      _vm._v(_vm._s(_vm.accountSubmissionNotes))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c(
                      "span",
                      { staticClass: "subsection-title font-italic" },
                      [
                        _vm._v(
                          "\n              Originally submitted by: " +
                            _vm._s(_vm.accountSubmissionContactName) +
                            "\n              (" +
                            _vm._s(_vm.accountSubmissionContactEmail) +
                            ")\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c(
                      "span",
                      { staticClass: "subsection-title font-italic" },
                      [
                        _vm._v(
                          "\n              Originally submitted as: " +
                            _vm._s(_vm.accountSubmissionCompanyName) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-flex", [
                    _c(
                      "span",
                      { staticClass: "subsection-title font-italic" },
                      [
                        _vm._v(
                          "\n              Originally submitted phone: " +
                            _vm._s(_vm.accountSubmissionPhone) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showOriginalSubmissionInfo = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.showVerifyDialog,
            callback: function($$v) {
              _vm.showVerifyDialog = $$v
            },
            expression: "showVerifyDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("v-card-title", { staticClass: "px-0" }, [
                    _vm._v(
                      "\n            Verifying means that the company will appear on listings and bids as a trusted company.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      rows: "3",
                      label: "Reason",
                      "error-messages": _vm.errors.first("reason", "verify"),
                      "data-vv-as": "Reason",
                      "data-vv-name": "reason",
                      "data-vv-scope": "verify",
                      "auto-grow": ""
                    },
                    model: {
                      value: _vm.dialogReason,
                      callback: function($$v) {
                        _vm.dialogReason = $$v
                      },
                      expression: "dialogReason"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled: _vm.errors.any("verify"),
                            loading: _vm.loadingBtn
                          },
                          on: { click: _vm.verifyCompany }
                        },
                        [_vm._v("Mark Verified")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showVerifyDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.showDisableAccountDialog,
            callback: function($$v) {
              _vm.showDisableAccountDialog = $$v
            },
            expression: "showDisableAccountDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("v-card-title", { staticClass: "px-0" }, [
                    _vm._v(
                      "\n            Placing a company on hold means they can't list or bid on loads.\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      rows: "3",
                      label: "Reason to place on hold",
                      "error-messages": _vm.errors.first("reason", "disable"),
                      "data-vv-as": "Reason",
                      "data-vv-name": "reason",
                      "data-vv-scope": "disable",
                      "auto-grow": ""
                    },
                    model: {
                      value: _vm.dialogReason,
                      callback: function($$v) {
                        _vm.dialogReason = $$v
                      },
                      expression: "dialogReason"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled: _vm.errors.any("disable"),
                            loading: _vm.loadingBtn
                          },
                          on: { click: _vm.disableCompany }
                        },
                        [_vm._v("Place on Hold")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showDisableAccountDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.showReenableAccountDialog,
            callback: function($$v) {
              _vm.showReenableAccountDialog = $$v
            },
            expression: "showReenableAccountDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("v-card-title", { staticClass: "px-0" }, [
                    _vm._v(
                      "\n            Remove the hold from the company's account\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      rows: "3",
                      "error-messages": _vm.errors.first(
                        "reason",
                        "removeHold"
                      ),
                      "data-vv-as": "Reason",
                      "data-vv-name": "reason",
                      "data-vv-scope": "removeHold",
                      label: "Reason",
                      "auto-grow": ""
                    },
                    model: {
                      value: _vm.dialogReason,
                      callback: function($$v) {
                        _vm.dialogReason = $$v
                      },
                      expression: "dialogReason"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled: _vm.errors.any("removeHold"),
                            loading: _vm.loadingBtn
                          },
                          on: { click: _vm.removeCompanyHold }
                        },
                        [_vm._v("Remove Hold")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showReenableAccountDialog = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDisabled
        ? _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { column: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "py-2 pl-5",
                  attrs: { color: "amber accent-4" }
                },
                [
                  _c("v-layout", { attrs: { "align-baseline": "" } }, [
                    _c(
                      "div",
                      { staticClass: "headline mr-3 mt-4 white-text" },
                      [
                        _c("v-icon", { attrs: { color: "white", large: "" } }, [
                          _vm._v("report")
                        ]),
                        _vm._v(" This account has a hold on it.\n          ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "font-weight-regular white-text" },
                      [_vm._v(_vm._s(_vm.companyDisabledReason))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { staticStyle: { overflow: "auto" }, attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { "xs-3": "" } },
                    [
                      _c(
                        "v-navigation-drawer",
                        { attrs: { permanent: "", floating: "" } },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pt-0", attrs: { dense: "" } },
                            [
                              _vm._l(_vm.companySettingsSections, function(
                                item
                              ) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: item.title,
                                    attrs: { to: "#" + item.tabItemKey },
                                    on: {
                                      click: function($event) {
                                        _vm.tab = item.tabItemKey
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-action",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color:
                                                _vm.tab == item.tabItemKey
                                                  ? "primary"
                                                  : ""
                                            }
                                          },
                                          [_vm._v(_vm._s(item.icon))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(_vm._s(item.title))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass:
                                              "font-italic font-weight-light"
                                          },
                                          [_vm._v(_vm._s(item.subtitle))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.isLtnAdmin ? _c("v-divider") : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.siteAdminSettingsSections, function(
                                item
                              ) {
                                return _vm.isLtnAdmin
                                  ? _c(
                                      "v-list-tile",
                                      {
                                        key: item.title,
                                        attrs: { to: "#" + item.tabItemKey },
                                        on: {
                                          click: function($event) {
                                            _vm.tab = item.tabItemKey
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color:
                                                    _vm.tab == item.tabItemKey
                                                      ? "primary"
                                                      : ""
                                                }
                                              },
                                              [_vm._v(_vm._s(item.icon))]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", [
                                              _vm._v(_vm._s(item.title))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "full-card-desktop",
                      staticStyle: { overflow: "auto" },
                      attrs: { xs9: "" }
                    },
                    [
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab-item",
                            {
                              attrs: { value: "contact_and_billing", lazy: "" }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "py-2 pl-5" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "align-baseline": "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "title mr-3 mt-4" },
                                        [
                                          _vm._v(
                                            "\n                  Company Details\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        column: "",
                                        sm12: "",
                                        xs12: "",
                                        md6: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: {
                                                sm12: "",
                                                xs12: "",
                                                md3: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Company Name",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.companyName,
                                                  callback: function($$v) {
                                                    _vm.companyName = $$v
                                                  },
                                                  expression: "companyName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: {
                                                sm12: "",
                                                xs12: "",
                                                md3: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Phone",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.contactPhone,
                                                  callback: function($$v) {
                                                    _vm.contactPhone = $$v
                                                  },
                                                  expression: "contactPhone"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _vm.isAdmin
                                            ? _c(
                                                "v-flex",
                                                {
                                                  staticClass: "mr-5",
                                                  attrs: { sm3: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: _vm.einLabel,
                                                      disabled: !_vm.isAdmin
                                                    },
                                                    model: {
                                                      value: _vm.ein,
                                                      callback: function($$v) {
                                                        _vm.ein = $$v
                                                      },
                                                      expression: "ein"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Website URL",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.website,
                                                  callback: function($$v) {
                                                    _vm.website = $$v
                                                  },
                                                  expression: "website"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Contact Name",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.contactName,
                                                  callback: function($$v) {
                                                    _vm.contactName = $$v
                                                  },
                                                  expression: "contactName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Logo URL",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.logoUrl,
                                                  callback: function($$v) {
                                                    _vm.logoUrl = $$v
                                                  },
                                                  expression: "logoUrl"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Contact Email",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.contactEmail,
                                                  callback: function($$v) {
                                                    _vm.contactEmail = $$v
                                                  },
                                                  expression: "contactEmail"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Billing Email",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.billingEmail,
                                                  callback: function($$v) {
                                                    _vm.billingEmail = $$v
                                                  },
                                                  expression: "billingEmail"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Night Contact Name",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.nightContactName,
                                                  callback: function($$v) {
                                                    _vm.nightContactName = $$v
                                                  },
                                                  expression: "nightContactName"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Night Phone",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.nightPhone,
                                                  callback: function($$v) {
                                                    _vm.nightPhone = $$v
                                                  },
                                                  expression: "nightPhone"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { "align-baseline": "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "title mr-3 mt-4" },
                                        [
                                          _vm._v(
                                            "\n                  Address\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "", sm6: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Street",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.addressStreet1,
                                                  callback: function($$v) {
                                                    _vm.addressStreet1 = $$v
                                                  },
                                                  expression: "addressStreet1"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "City",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.addressCity,
                                                  callback: function($$v) {
                                                    _vm.addressCity = $$v
                                                  },
                                                  expression: "addressCity"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label:
                                                    "Suite or Building Number",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.addressStreet2,
                                                  callback: function($$v) {
                                                    _vm.addressStreet2 = $$v
                                                  },
                                                  expression: "addressStreet2"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "State",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.addressRegion,
                                                  callback: function($$v) {
                                                    _vm.addressRegion = $$v
                                                  },
                                                  expression: "addressRegion"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c("v-flex", {
                                            staticClass: "mr-5",
                                            attrs: { sm3: "" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Postal Code",
                                                  disabled: !_vm.isAdmin
                                                },
                                                model: {
                                                  value: _vm.addressPostalCode,
                                                  callback: function($$v) {
                                                    _vm.addressPostalCode = $$v
                                                  },
                                                  expression:
                                                    "addressPostalCode"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown,
                                            "align-baseline": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title mr-3 mt-4" },
                                            [
                                              _vm._v(
                                                "\n                    Billing Address\n\n                    "
                                              ),
                                              _vm._.get(
                                                _vm.company,
                                                "producerInfo.billingAddress.label"
                                              ) && _vm.isAdmin
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "accent",
                                                      attrs: { flat: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeProducerInfo()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "pr-2",
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [_vm._v("cancel")]
                                                      ),
                                                      _vm._v(
                                                        "\n                      Remove " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "booked-load.producer"
                                                            )
                                                          ) +
                                                          " Info\n                    "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "pl-2 mr5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Load " +
                                                  _vm._s(
                                                    _vm
                                                      .$tc(
                                                        "booked-load.producers",
                                                        2
                                                      )
                                                      .toLocaleLowerCase()
                                                  ) +
                                                  " provide a freight Billing Address and can post to the load\n                    board.\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _vm.isAdmin
                                                ? _c("v-checkbox", {
                                                    attrs: {
                                                      label:
                                                        "Billing Address is same as above."
                                                    },
                                                    model: {
                                                      value: _vm.copyAddress,
                                                      callback: function($$v) {
                                                        _vm.copyAddress = $$v
                                                      },
                                                      expression: "copyAddress"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.copyAddress &&
                                      _vm.company.producerInfo &&
                                      _vm.company.producerInfo.billingAddress
                                        ? _c(
                                            "v-layout",
                                            { attrs: { column: "", sm6: "" } },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    column:
                                                      _vm.$vuetify.breakpoint
                                                        .smAndDown
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Street 1",
                                                          disabled: !_vm.isAdmin
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billingAddressStreet1,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.billingAddressStreet1 = $$v
                                                          },
                                                          expression:
                                                            "billingAddressStreet1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "City",
                                                          disabled: !_vm.isAdmin
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billingAddressCity,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.billingAddressCity = $$v
                                                          },
                                                          expression:
                                                            "billingAddressCity"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    column:
                                                      _vm.$vuetify.breakpoint
                                                        .smAndDown
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Street 2",
                                                          disabled: !_vm.isAdmin
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billingAddressStreet2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.billingAddressStreet2 = $$v
                                                          },
                                                          expression:
                                                            "billingAddressStreet2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "State",
                                                          disabled: !_vm.isAdmin
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billingAddressRegion,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.billingAddressRegion = $$v
                                                          },
                                                          expression:
                                                            "billingAddressRegion"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    column:
                                                      _vm.$vuetify.breakpoint
                                                        .smAndDown
                                                  }
                                                },
                                                [
                                                  _c("v-flex", {
                                                    staticClass: "mr-5",
                                                    attrs: { sm3: "" }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Postal Code",
                                                          disabled: !_vm.isAdmin
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billingAddressPostalCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.billingAddressPostalCode = $$v
                                                          },
                                                          expression:
                                                            "billingAddressPostalCode"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _vm.isAdmin
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "accent",
                                                  on: {
                                                    click: _vm.updateSettings
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Save\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { attrs: { value: "loading_chutes", lazy: "" } },
                            [
                              _vm.company
                                ? _c("loading-chutes-section", {
                                    attrs: {
                                      company: _vm.company,
                                      "is-admin": _vm.isAdmin
                                    },
                                    on: { refresh: _vm.loadCompany }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { attrs: { value: "trucking", lazy: "" } },
                            [
                              _c(
                                "v-card",
                                { staticClass: "py-2 pl-5 pr-5" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        column:
                                          _vm.$vuetify.breakpoint.smAndDown,
                                        "align-baseline": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "title mr-3 mt-4" },
                                        [
                                          _vm._v(
                                            "\n                  Trucking Info\n\n                  "
                                          ),
                                          _vm.truckingDotNumber && _vm.isAdmin
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "accent",
                                                  attrs: { flat: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeTruckingInfo()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "pr-2",
                                                      attrs: { color: "white" }
                                                    },
                                                    [_vm._v("cancel")]
                                                  ),
                                                  _vm._v(
                                                    "\n                    Remove\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pl-2 mr5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Providing your Trucking Company's information allows you to bid on loads.\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTruckingCompanySection
                                    ? _c(
                                        "v-layout",
                                        { attrs: { column: "", sm6: "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "mr-5",
                                                  attrs: { sm3: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Dot Number",
                                                      disabled: !_vm.isAdmin
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.truckingDotNumber,
                                                      callback: function($$v) {
                                                        _vm.truckingDotNumber = $$v
                                                      },
                                                      expression:
                                                        "truckingDotNumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.hasFullAccess
                                            ? [
                                                _c(
                                                  "v-layout",
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        staticClass: "mr-5",
                                                        attrs: { sm2: "" }
                                                      },
                                                      [
                                                        _c("upload-button", {
                                                          staticClass:
                                                            "cursor-pointer",
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "company-profile.vendor-tax-document"
                                                            )
                                                          },
                                                          on: {
                                                            files:
                                                              _vm.w9FileUpload
                                                          },
                                                          model: {
                                                            value: _vm.w9File,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.w9File = $$v
                                                            },
                                                            expression: "w9File"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._.get(
                                                      _vm.company,
                                                      "truckingInfo.w9.link",
                                                      false
                                                    )
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "mr-5 pt-2",
                                                            attrs: {
                                                              sm5: "",
                                                              "align-baseline":
                                                                ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.openFile(
                                                                      _vm
                                                                        .company
                                                                        .truckingInfo
                                                                        .w9.link
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .company
                                                                        .truckingInfo
                                                                        .w9.name
                                                                    ) +
                                                                    ".pdf\n                      "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-layout", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pl-2 mr5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Your " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "company-profile.vendor-tax-document"
                                                            )
                                                          ) +
                                                          " is shared only with " +
                                                          _vm._s(
                                                            _vm
                                                              .$t(
                                                                "booked-load.producer"
                                                              )
                                                              .toLocaleLowerCase()
                                                          ) +
                                                          " companies you haul for.\n                  "
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-layout",
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      {
                                                        staticClass: "mr-5",
                                                        attrs: { sm2: "" }
                                                      },
                                                      [
                                                        _c("upload-button", {
                                                          staticClass:
                                                            "cursor-pointer",
                                                          attrs: {
                                                            label:
                                                              "Insurance Policy"
                                                          },
                                                          on: {
                                                            files:
                                                              _vm.insuranceFileUpload
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.insuranceFile,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.insuranceFile = $$v
                                                            },
                                                            expression:
                                                              "insuranceFile"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._.get(
                                                      _vm.company,
                                                      "truckingInfo.insurancePolicy.link",
                                                      false
                                                    )
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            staticClass: "mr-5",
                                                            attrs: { sm5: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.openFile(
                                                                      _vm
                                                                        .company
                                                                        .truckingInfo
                                                                        .insurancePolicy
                                                                        .link
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .company
                                                                        .truckingInfo
                                                                        .insurancePolicy
                                                                        .name
                                                                    ) +
                                                                    ".pdf\n                      "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-layout", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pl-2 mr5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Your Insurance Policy is shared with companies whose loads\n                      you bid on or " +
                                                          _vm._s(
                                                            _vm
                                                              .$t(
                                                                "booked-load.producer"
                                                              )
                                                              .toLocaleLowerCase()
                                                          ) +
                                                          " companies you haul for.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-layout",
                                                  { staticClass: "mt-3" },
                                                  [
                                                    _vm.isAdmin
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "accent ml-0",
                                                            on: {
                                                              click:
                                                                _vm.updateTruckingInfo
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Save\n                    "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm.hasFullAccess
                                    ? _c(
                                        "v-layout",
                                        [
                                          _vm.isAdmin
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "accent",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showTruckingCompany = true
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "mr-2" },
                                                    [_vm._v("add_circle")]
                                                  ),
                                                  _vm._v(
                                                    "\n                  Add Trucking Company Details\n                "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.hasFullAccess &&
                              _vm.showTruckingCompanySection
                                ? _c(
                                    "v-card",
                                    { staticClass: "py-2 pl-5 pr-5 mt-3" },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column:
                                              _vm.$vuetify.breakpoint.smAndDown,
                                            "align-baseline": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title mr-3 mt-4" },
                                            [
                                              _vm._v(
                                                "\n                  Notify Insurance Company\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-container",
                                        {
                                          attrs: {
                                            "grid-list-md": "",
                                            "text-xs-center": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { xs12: "", md6: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    attrs: {
                                                      label: "Agent Name",
                                                      "data-vv-as":
                                                        "Agent Name",
                                                      "data-vv-name": "agent",
                                                      "data-vv-scope":
                                                        "insurance",
                                                      "browser-autocomplete":
                                                        "off",
                                                      "error-messages": _vm.errors.first(
                                                        "agent",
                                                        "insurance"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.insuranceAgent,
                                                      callback: function($$v) {
                                                        _vm.insuranceAgent = $$v
                                                      },
                                                      expression:
                                                        "insuranceAgent"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { xs12: "", md6: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required|email",
                                                        expression:
                                                          "'required|email'"
                                                      }
                                                    ],
                                                    attrs: {
                                                      label: "Agent Email",
                                                      "data-vv-as":
                                                        "Agent Email",
                                                      "data-vv-name": "email",
                                                      "data-vv-scope":
                                                        "insurance",
                                                      "browser-autocomplete":
                                                        "off",
                                                      "error-messages": _vm.errors.first(
                                                        "email",
                                                        "insurance"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.insuranceEmail,
                                                      callback: function($$v) {
                                                        _vm.insuranceEmail = $$v
                                                      },
                                                      expression:
                                                        "insuranceEmail"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { xs12: "", md6: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    attrs: {
                                                      label:
                                                        "Insurance Company",
                                                      "data-vv-as":
                                                        "Insurance Company",
                                                      "data-vv-name": "company",
                                                      "data-vv-scope":
                                                        "insurance",
                                                      "browser-autocomplete":
                                                        "off",
                                                      "error-messages": _vm.errors.first(
                                                        "company",
                                                        "insurance"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.insuranceCompany,
                                                      callback: function($$v) {
                                                        _vm.insuranceCompany = $$v
                                                      },
                                                      expression:
                                                        "insuranceCompany"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "" } },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  '\n                    Look for an email with a subject "Insurance Certificate Request"\n                    from "' +
                                                    _vm._s(
                                                      _vm.$t("site-title.brief")
                                                    ) +
                                                    ' Account Management": contact@livestocktransportnation.com\n                  '
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.hasCertificate
                                            ? [
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: { column: "" }
                                                  },
                                                  [
                                                    _vm._.get(
                                                      _vm.policyCertificate,
                                                      "requested",
                                                      false
                                                    )
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Requested by: "
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm._.get(
                                                                    _vm.policyCertificate,
                                                                    "requestedBy",
                                                                    ""
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                            _c("i", [
                                                              _vm._v(
                                                                "\n                        (" +
                                                                  _vm._s(
                                                                    _vm._.get(
                                                                      _vm.policyCertificate,
                                                                      "requestedByEmail",
                                                                      ""
                                                                    )
                                                                  ) +
                                                                  ")\n                      "
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c("b", [
                                                              _vm._v("Date: ")
                                                            ]),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatDate"
                                                                  )(
                                                                    _vm._.get(
                                                                      _vm.policyCertificate,
                                                                      "requested",
                                                                      ""
                                                                    )
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                            _c("br")
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm._.get(
                                                      _vm.policyCertificate,
                                                      "Confirmed",
                                                      false
                                                    )
                                                      ? _c("v-flex", [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Confirmed by: "
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm._.get(
                                                                  _vm.policyCertificate,
                                                                  "confirmedBy",
                                                                  ""
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                          _c("i", [
                                                            _vm._v(
                                                              "\n                        (" +
                                                                _vm._s(
                                                                  _vm._.get(
                                                                    _vm.policyCertificate,
                                                                    "confirmedByEmail",
                                                                    ""
                                                                  )
                                                                ) +
                                                                ")\n                      "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v("Date: ")
                                                          ]),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatDate"
                                                                )(
                                                                  _vm._.get(
                                                                    _vm.policyCertificate,
                                                                    "confirmed",
                                                                    ""
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                          _c("br")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm._.get(
                                                      _vm.policyCertificate,
                                                      "emailSent",
                                                      false
                                                    ) &&
                                                    _vm._.get(
                                                      _vm.policyCertificate,
                                                      "emailSent",
                                                      []
                                                    ).length
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "subheading mt-2 flex text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        Emails sent to Agent:\n                      "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm._.get(
                                                                _vm.policyCertificate,
                                                                "emailSent",
                                                                []
                                                              ),
                                                              function(
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "v-list-tile",
                                                                  {
                                                                    key:
                                                                      "email_" +
                                                                      index,
                                                                    attrs: {
                                                                      avatar: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-tile-action",
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "accent"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "email"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-list-tile-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-tile-title",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm._f(
                                                                                    "formatDate"
                                                                                  )(
                                                                                    item
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "accent ml-0 mr-3 my-0",
                                                  attrs: {
                                                    disabled: _vm.errors.any(
                                                      "insurance"
                                                    ),
                                                    loading: _vm.loadingBtn
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.notifyInsurance()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Save\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.hasCertificate
                                                ? [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "primary ml-0 mr-3 my-0",
                                                        attrs: {
                                                          disabled: _vm.errors.any(
                                                            "insurance"
                                                          ),
                                                          loading:
                                                            _vm.loadingBtn
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.notifyInsurance()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Remind Agent\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isLtnAdmin
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "accent ml-0 mr-3 my-0",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openConfirmDialog()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Confirm Insurance Certificate\n                    "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasFullAccess
                            ? _c(
                                "v-tab-item",
                                {
                                  key: "Invoicing",
                                  attrs: { value: "invoicing", lazy: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "align-baseline": "" } },
                                    [
                                      _vm.company && _vm.company.id
                                        ? _c("invoicing-section", {
                                            attrs: { company: _vm.company },
                                            on: { refresh: _vm.loadCompany }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasFullAccess
                            ? _c(
                                "v-tab-item",
                                {
                                  key: "Load Defaults",
                                  attrs: { value: "load_defaults", lazy: "" }
                                },
                                [
                                  _vm.company && _vm.company.id
                                    ? _c("checklist-section", {
                                        attrs: { company: _vm.company },
                                        on: { refresh: _vm.loadCompany }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isLtnAdmin
                            ? _c(
                                "v-tab-item",
                                {
                                  key: "AdminTools",
                                  attrs: { value: "admin_tools", lazy: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "py-2 pb-4 pl-5 pr-5 mt-3" },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { "align-baseline": "" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title mr-3 mt-4" },
                                            [
                                              _vm._v(
                                                "\n                  Company Load Code\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "pl-2 mr5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  In the event this company got a wrong or inappropriate code.\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { column: "", sm6: "" }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { sm6: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Company Code"
                                                },
                                                model: {
                                                  value: _vm.companyCode,
                                                  callback: function($$v) {
                                                    _vm.companyCode = $$v
                                                  },
                                                  expression: "companyCode"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "accent" },
                                                  on: {
                                                    click: _vm.updateCompanyCode
                                                  }
                                                },
                                                [_vm._v("Update")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isLtnAdmin
                            ? _c(
                                "v-tab-item",
                                { attrs: { value: "timeline", lazy: "" } },
                                [
                                  _vm.isLtnAdmin
                                    ? _c(
                                        "v-card",
                                        {
                                          staticClass:
                                            "pt-2 pb-4 pl-5 pr-5 mt-3"
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { "align-baseline": "" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "title mr-3 mt-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Account History "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.loadTimeline()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("refresh")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              staticClass: "mt-2",
                                              attrs: {
                                                wrap: "",
                                                "justify-start": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { sm12: "", md8: "" }
                                                },
                                                [
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      block: "",
                                                      rows: 2,
                                                      label: "Type something..."
                                                    },
                                                    model: {
                                                      value: _vm.msgText,
                                                      callback: function($$v) {
                                                        _vm.msgText = $$v
                                                      },
                                                      expression: "msgText"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "px-1",
                                                  attrs: { sm12: "", md2: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mr-1 px-0",
                                                      attrs: {
                                                        block: "",
                                                        loading: _vm.loadingBtn,
                                                        disabled: _vm.loadingBtn
                                                      },
                                                      on: {
                                                        click: _vm.sendMessage
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    Send\n                  "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.timeline
                                            ? _c("timeline", {
                                                attrs: {
                                                  showTime: "",
                                                  "timeline-object":
                                                    _vm.timeline
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasFullAccess
                            ? _c(
                                "v-tab-item",
                                { attrs: { value: "permissions", lazy: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { elevation: "1" } },
                                    [
                                      _vm.company && _vm.company.id
                                        ? _c("employees-section", {
                                            attrs: {
                                              company: _vm.company,
                                              "is-admin": _vm.isAdmin
                                            },
                                            on: {
                                              refresh: _vm.loadCompany,
                                              "add-new": function($event) {
                                                _vm.showAddEmployeeDialog = true
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin &&
                                      _vm.company &&
                                      _vm.company.id
                                        ? _c("invitations-section", {
                                            attrs: { company: _vm.company },
                                            on: { refresh: _vm.loadCompany }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasFullAccess
                            ? _c(
                                "v-tab-item",
                                { attrs: { value: "dispatching", lazy: "" } },
                                [
                                  _vm.company && _vm.company.id
                                    ? _c("dispatching-info-section", {
                                        attrs: { company: _vm.company }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba0ba7ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0ba7ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Settings.vue
// module id = null
// module chunks = 